__turbopack_context__.v({
  "benefit": "ShareEvent-module-scss-module__p-kzSq__benefit",
  "description": "ShareEvent-module-scss-module__p-kzSq__description",
  "gift_card_image": "ShareEvent-module-scss-module__p-kzSq__gift_card_image",
  "logo": "ShareEvent-module-scss-module__p-kzSq__logo",
  "naver": "ShareEvent-module-scss-module__p-kzSq__naver",
  "sticky_background": "ShareEvent-module-scss-module__p-kzSq__sticky_background",
  "summary": "ShareEvent-module-scss-module__p-kzSq__summary",
  "title": "ShareEvent-module-scss-module__p-kzSq__title",
});
